import React, { useEffect, useRef, useMemo, Fragment } from 'react';
import { observer } from 'mobx-react-lite';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SVGPureIcon } from '@/ui';
import { HelperCore, HelpOther } from '@/common/helper';
import userStore from '@/store/user';
import navbarStore from '@/store/navbar';
import { sendBroadcast, useBroadcast } from '@/hooks/useBroadcast';
import EE from '@/common/event';
import globalStore from '@/store/global';
import ScrollView from '@/ui/scroll-view';
import deleteMenuStore from './delete-mune/store';
import { Tooltip } from 'antd';
import AppCheckBox from '@/ui/checkbox';
import AisoItem from './aiso-item';
import LoginBtn from './login-btn';
import { goSearchHistory, newSearch } from '@src/pages/search';
import appLogger from '@public/log/monitor';
import inputTypeStore from '../input-file/input-type';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import chatStoreManager from '@/store/chat/manager';

const AisoHistory = observer(props => {
  const { getHistory, getConversationHistoryById, historyList: listData, historyNpt } = navbarStore;
  const { className, showSearchInput } = props;

  const { id } = useParams();
  
  useBroadcast('history-changed', data => {

  });

  // 多端同步 - 机器人会话历史
  const handleHistory = data => {
    console.log('多端同步 - 会话', data);
    getHistory(true);
  };
  useEffect(() => {
    EE.on('assistant_history', handleHistory);

    return () => {
      EE.off('assistant_history', handleHistory);
    };
  }, []);

  useEffect(() => {
    // 监听删除菜单的变化
    navbarStore.setCurConversationId(id);
  },[]);

  // 非登录状态下获取历史数据
  useEffect(() => {
    if (navbarStore.sourceId === 1) {
      getHistory(true);
    }
  }, [navbarStore.sourceId]);

  // 修改 mixedArr 的计算逻辑
  const mixedArr = useMemo(() => {
    if (!listData) return [];

    // 按时间分组
    const groups = {};
    listData.forEach(item => {
      const group = HelperCore.getTimeGroup(item);
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(item);
    });

    // 构建最终数组
    const result = [];
    ['置顶', '今天', '昨天', '前天', '最近7天', '更早'].forEach(group => {
      if (groups[group] && groups[group].length > 0) {
        result.push({
          type: 'group',
          title: group,
          update_time: groups[group][0].update_time,
        });
        result.push(...groups[group]);
      }
    });

    // 添加年份分组
    Object.keys(groups)
      .filter(group => group.includes('年'))
      .sort((a, b) => parseInt(b) - parseInt(a))
      .forEach(year => {
        result.push({
          type: 'group',
          title: year,
          update_time: groups[year][0].update_time,
        });
        result.push(...groups[year]);
      });
    //置顶排序，后置顶的在上面
    result.sort((a, b) => b.pin_top_time - a.pin_top_time);
    return result;
  }, [listData, listData?.length]);

  return (
    <>
      <div
        className={['relative flex flex-col h-0 flex-grow pr-4px', className]}
        style={{
          paddingBottom: deleteMenuStore.isEdit ? '98px':'',
        }}
      >
        <ScrollView scrollY id="history_wrap" className="h-0 flex-grow">
          <InfiniteScroll
            dataLength={mixedArr?.length}
            next={evt => {
              getHistory();
            }}
            hasMore={!!historyNpt}
            loader={null}
            className="pl-14px pr-4px flex flex-col gap-12px"
            scrollableTarget="history_wrap"
          >
            {mixedArr?.map((item, index, arr) => {
              // 日期分组信息
              if (item.type === 'group') {
                const isFirst = index == 0;
                if (index === arr.length - 1) return null;
                let next = arr[index + 1];
                if (next.type && next.type === 'group') return null;
                return (
                  <Fragment key={item.conversation_id || index}>
                    <div
                      className={[
                        'text-12px leading-17px text-[#00000080]',
                        globalStore.isDark ? '!text-[#FFFFFF80]' : '',
                        isFirst ? 'mt-6px' : 'mt-4px',
                      ]}
                    >
                      {item.title}
                    </div>
                  </Fragment>
                );
              }
              return (
                <div
                  className={[
                    'flex gap-8px',
                    'text-12px text-[#00000080] leading-32px',
                    globalStore.isDark ? '!text-[#FFFFFF80]' : '',
                  ]}
                  key={item.conversation_id || index}
                >
                  {deleteMenuStore.isEdit ? (
                    <AppCheckBox
                      className="!block !w-16px !h-16px !min-w-16px !min-h-16px mt-16px cursor-pointer"
                      checked={
                        deleteMenuStore.deleteIds.includes(item.conversation_id)
                      }
                      onClick={evt => {
                        if (deleteMenuStore.isEdit) {
                          deleteMenuStore.toggleDeleteId(item.conversation_id);
                        }
                      }}
                    />
                  ) : null}
                  <AisoItem
                    key={item.conversation_id || index}
                    index={index}
                    item={item}
                  />
                </div>
              );
            })}
            {
              !userStore.isUser ? <LoginBtn className={"mt-16px ml-12px mr-8px"}/> : null
            }
            <div className='h-40px'></div>
          </InfiniteScroll>
        </ScrollView>
      </div>
    </>
  );
});
export default AisoHistory;
